import { Palette } from '@mui/material'
import { TypographyOptions } from '@mui/material/styles/createTypography'
import '@fontsource/noto-sans/300.css';
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/700.css';

function getTypographyOverrides():TypographyOptions | ((palette: Palette) => TypographyOptions) {
  return {
    fontFamily: "'Noto Sans', sans-serif",
  }
}

export default getTypographyOverrides